import React from 'react';

import { ratePercent } from '../domain/feeRate.js';
import { formatUnits } from '../format';

/** IP-203: ' (1%)' beside a fee price - the rate it was struck at - or nothing for a price struck before 0038. */
const withRate = (rate) => (ratePercent(rate) ? ' (' + ratePercent(rate) + ')' : '');

/**
 * A price card's two fee prices on one line (registry.css price-card-fees):
 * the buying price with the exit fee, and on the right the selling price with
 * the front-end fee (IP-179) - one markup for the Unit Prices cards and the
 * Fund Register's, so the two read alike. Each shows the rate it was struck at
 * (IP-203). A fund that charges no such fee says so: since IP-203 a fund with
 * no front-end fee has no selling price with one.
 *
 * @param {{ price: { buyingPriceWithExitFee?: string|null, sellingPriceWithEntryFee?: string|null,
 *   exitFeeRate?: string|null, entryFeeRate?: string|null } }} props
 */
const PriceFees = ({ price }) => (
    <div className="price-card-fees">
        <dl className="price-card-exit">
            <dt>Buying with exit fee</dt>
            <dd>{price.buyingPriceWithExitFee ? formatUnits(price.buyingPriceWithExitFee) + withRate(price.exitFeeRate) : 'No exit fee'}</dd>
        </dl>
        <dl className="price-card-exit">
            <dt>Selling with front-end fee</dt>
            <dd>{price.sellingPriceWithEntryFee ? formatUnits(price.sellingPriceWithEntryFee) + withRate(price.entryFeeRate) : 'No front-end fee'}</dd>
        </dl>
    </div>
);

export default PriceFees;
